import BreadcrumbTitle from "components/BreadcrumbTitle"
import { SaveButton } from "components/Buttons"
import PageMetaTags from "components/PageMetaTags"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { withRouter, generatePath } from "react-router-dom"
import { Card, CardBody, Col, Container, Row } from "reactstrap"
import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts"
import {
  getFeatureClicks,
  getFeatureViewsByUser,
  getWebLink,
  getWebLinkClicks,
  resetFeatureClicks,
  resetFeatureViewsByUser,
  resetWebLink,
  resetWebLinkClicks,
} from "store/actions"
import UserList from "../userList"
import { generateLinkViews } from "./utils"
import ModalComponent from "components/Modals"
import { URL_PATHS } from "constants/index"

const WebLinkReports = ({
  history,
  match,
  getWebLink,
  resetWebLink,
  getFeatureViewsByUser,
  resetFeatureViewsByUser,
  getWebLinkClicks,
  resetWebLinkClicks,
  webLinkClicks,
  webLink,
}) => {
  const { event_id, feature_id } = match?.params
  const COLORS = ["#556ee6", "#ffc83d", "#8884d8", "#82ca9d"]
  const [links, setLinks] = useState([])
  useEffect(() => {
    getWebLink(feature_id)
    getWebLinkClicks({ id: feature_id })
    return () => {
      resetWebLink()
      resetWebLinkClicks()
      resetFeatureViewsByUser()
    }
  }, [])

  useEffect(() => {
    if (webLink && webLinkClicks) {
      const data = []
      for (const index in webLink?.promo_links) {
        data.push({
          name: webLink?.promo_links[index]?.label,
          id: webLink?.promo_links[index]?.id,
          ...webLinkClicks[webLink?.promo_links[index]?.id],
        })
      }
      setLinks(data)
    }
  }, [webLink, webLinkClicks])

  const [selectedLink, setSelectedLink] = useState(null)
  const [detailsModalIsOpen, setDetailsModalIsOpen] = useState(false)

  const handleBarClick = data => {
    setSelectedLink(links.find(x => x.id == data))
    getFeatureViewsByUser({
      feature_id: data,
      feature: "web_link",
      page: 1,
      per_page: 10,
    })
    setDetailsModalIsOpen(true)
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <PageMetaTags title="Web Link Reports" />
          <BreadcrumbTitle
            title={webLink?.label || ""}
            breadcrumbItems={[
              { title: "Dashboard" },
              {
                title: "Experience Reports",
                link: generatePath(URL_PATHS.EVENT_REPORTS, { id: event_id }),
              },
              { title: "Web Link Report" },
            ]}
          />
          <Row className="d-flex justify-content-end mb-3">
            <Col xs="auto">
              <SaveButton
                type="button"
                color="light"
                content="Back"
                onClick={() => {
                  history.goBack()
                }}
              />
            </Col>
          </Row>
          <Card>
            <CardBody>
              <Row>
                <Col>
                  <Row className="ms-4">
                    <Col>
                      <h6>Web Link Views (last 7 days)</h6>
                    </Col>
                  </Row>
                  <Row className="ms-3" style={{ height: "500px" }}>
                    <Col>
                      <ResponsiveContainer>
                        <BarChart
                          data={
                            !!webLinkClicks
                              ? generateLinkViews(7, webLinkClicks)
                              : []
                          }
                          width={500}
                          height={500}
                          margin={{
                            top: 20,
                            right: 30,
                            left: 20,
                            bottom: 15,
                          }}
                        >
                          <CartesianGrid strokeDasharray="3 3" />
                          <XAxis
                            dataKey="date"
                            tick={{
                              stroke: "black",
                              strokeWidth: 0.5,
                            }}
                            dy={10}
                            label={{
                              value: "Date",
                              position: "bottom",
                            }}
                            angle={-20}
                          />
                          <YAxis
                            label={{
                              value: "# of Clicks",
                              angle: -90,
                              position: "insideLeft",
                            }}
                            tick={{
                              stroke: "black",
                              strokeWidth: 0.5,
                            }}
                            dx={-10}
                            allowDecimals={false}
                          />
                          <Tooltip
                            cursor={{ fill: "rgb(220, 220, 220, 0.5)" }}
                          />
                          <Legend verticalAlign="top" />
                          {webLinkClicks &&
                            Object.keys(webLinkClicks)?.map((x, index) => {
                              return (
                                <Bar
                                  key={index}
                                  dataKey={x}
                                  name={links?.find(item => item.id == x)?.name}
                                  fill={COLORS[index]}
                                  maxBarSize={50}
                                  onClick={data => {
                                    handleBarClick(x)
                                  }}
                                  id={x}
                                  //   label={props => {
                                  //     console.log("props", props)
                                  //     return (
                                  //       <text
                                  //         x={props?.x}
                                  //         y={props?.y}
                                  //         dy={-15}
                                  //         dx={25}
                                  //         fontSize={14}
                                  //         textAnchor="middle"
                                  //       >
                                  //         {props?.value > 0 ? "" : "No Views"}
                                  //       </text>
                                  //     )
                                  //   }}
                                />
                              )
                            })}
                        </BarChart>
                      </ResponsiveContainer>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </CardBody>
          </Card>
          <ModalComponent
            open={detailsModalIsOpen}
            onClose={() => {
              setDetailsModalIsOpen(false)
              setSelectedLink(null)
              resetFeatureViewsByUser()
            }}
            size="xl"
            scrollable={true}
            title={selectedLink?.name + " Report"}
          >
            <Row className="ms-2">
              <Col>
                <span>
                  <label>Total Views: </label>
                  {!!selectedLink?.total_views
                    ? " " + selectedLink?.total_views
                    : " 0"}
                </span>
              </Col>
            </Row>
            <Row className="ms-2">
              <Col>
                <span>
                  <label>Percentage of Views: </label>
                  {!!selectedLink?.total_views
                    ? " " + selectedLink?.users_percentage + "%"
                    : " 0%"}
                </span>
              </Col>
            </Row>
            <Row className="ms-2">
              <Col>
                <span>
                  <label>Top User: </label>
                  {!!selectedLink?.top_user
                    ? " " + selectedLink?.top_user?.display_name
                    : " -"}
                </span>
              </Col>
            </Row>
            <UserList
              event_id={event_id}
              feature_name="web_link"
              report_name="Web Link Report"
            />
          </ModalComponent>
        </Container>
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  webLink: state.WebLink.webLink,
  featureClicks: state.Analytics.featureClicks,
  featureViewsByUser: state.Analytics.featureViewsByUser,
  webLinkClicks: state.WebLink.webLinkClicks,
})

const mapDispatchToProps = dispatch => ({
  getWebLink: values => dispatch(getWebLink(values)),
  resetWebLink: values => dispatch(resetWebLink()),
  getFeatureClicks: values => dispatch(getFeatureClicks(values)),
  resetFeatureClicks: () => dispatch(resetFeatureClicks()),
  getFeatureViewsByUser: values => dispatch(getFeatureViewsByUser(values)),
  resetFeatureViewsByUser: () => dispatch(resetFeatureViewsByUser()),
  getWebLinkClicks: values => dispatch(getWebLinkClicks(values)),
  resetWebLinkClicks: () => dispatch(resetWebLinkClicks()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(WebLinkReports))
